/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
//standard libraries
import React from "react";

export const useSidebar = () => {
  const [showForm, setShowForm] = React.useState(true);
  const [showdialog, setShowdialog] = React.useState(false);
  const [showEditForm, setShoweditForm] = React.useState(false);
  const [showCustomerControl, setShowCustomerControl] = React.useState(false);

  return {
    showForm,
    setShowForm,
    setShowdialog,
    showdialog,
    showEditForm,
    setShoweditForm,
    showCustomerControl,
    setShowCustomerControl,
  };
};
